import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import '@fortawesome/fontawesome-free/css/all.min.css';
import "./style.css";
import Navbar from '../../components/Navbar';

const ThankYou = () => {
  const [accessGranted, setAccessGranted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      const isFormSubmitted = sessionStorage.getItem("formSubmitted");

      if (isFormSubmitted) {
        setAccessGranted(true);
      } else {
        navigate("/");
      }
    }, 100); // Small delay to ensure sessionStorage is read correctly
  }, [navigate]);

  if (!accessGranted) {
    return null;
  }

  return (
    <>
      <Navbar />
      <section className="ul-facilites">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="ul-facilites--list">
                <li>
                  <b className="global-subheading global-fw600">
                    Thank You for Your Application!
                  </b>
                  <p>Dear {sessionStorage.getItem("applicationName") ?? 'Applicant'},</p>
                  <p>
                    Thank you for submitting your application to{" "}
                    <strong>Sitare University</strong>! Our admissions team will
                    review your application and notify you of next steps soon.
                  </p>
                  <p>
                    If you have any questions, reach out to our admissions office at  <a href="mailto:university@sitare.org" style={{ textDecoration: 'none', color: '#007BFF' }}>
                      university@sitare.org
                    </a>
                  </p>
                  <p>
                    You can also find more information on our <a style={{ textDecoration: "none", color: '#007BFF' }} href="https://univ.sitare.org/admissions">admissions</a> page
                  </p>
                  <p>
                    <em>- Sitare University Admissions Team</em>
                  </p>
                </li>
                <div className="social-icons" style={{ textAlign: "center", marginTop: "20px" }}>
                  Smart applicants stay connected. Don’t miss out. Follow us now! <br /><br />
                  <a href="https://www.linkedin.com/school/sitare-university/" target="_blank" rel="noopener noreferrer" style={{ margin: "0 10px" }}>
                    <img src="/assets/logo/linkedin.png" alt="LinkedIn" width="30" height="30" />
                  </a>
                  <a href="https://www.youtube.com/@SitareUniversity" target="_blank" rel="noopener noreferrer" style={{ margin: "0 10px" }}>
                    <img src="/assets/logo/youtube.png" alt="Youtube" width="30" height="30" />
                  </a>
                  <a href="https://www.instagram.com/sitareuniv" target="_blank" rel="noopener noreferrer" style={{ margin: "0 10px" }}>
                    <img src="/assets/logo/insta.jpeg" alt="Instagram" width="30" height="30" />
                  </a>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>

  );

};

export default ThankYou;

